
import Clarity from '@microsoft/clarity';
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import { FooterButton } from "../../common/footer/FooterButton";
import Header from "../../common/header/Header";
import CreateSection from "./create/CreateSection";
import ExpertiseSection from "./expertise/ExpertiseSection";
import MyWorkshopSection from "./my_workshop/MyWorkshopSection";
import SearchSection from "./search/SearchSection";
import WorkshopSection from "./workshop/WorkshopSection";

export default function WorkshopList() {
	Clarity.init(CLARITY_PROJECT_ID);
	const navigate = useNavigate();
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'کارگاه‌ها', href: '/workshop_list/' },
	];
	const [searchParams, setSearchParams] = useSearchParams();
	const expertiseIdParam = searchParams.get('expertise_id');
	const queryParam = searchParams.get('query');

	function onExpertiseClick(newExpertiseId) {
		if (String(newExpertiseId) !== String(expertiseIdParam)) {
			navigate(`/workshop_list/?expertise_id=${newExpertiseId ? newExpertiseId : ''}&query=${queryParam ? queryParam : ''}`);
		} else {
			navigate(`/workshop_list/?expertise_id=&query=${queryParam ? queryParam : ''}`);
		}
	}

	function onSearch(newQuery) {
		if (newQuery === queryParam) {
			return;
		}
		navigate(`/workshop_list/?expertise_id=${expertiseIdParam ? expertiseIdParam : ''}&query=${newQuery ? newQuery : ''}`);
	}

	return (
		<>
			<Helmet>
				<title>کارگاه‌ها | همراهتیم</title>
				<meta name="description" content="فهرست کارگاه‌های همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'w-[1200px]' : ''} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div
						className={`${isDesktop ? "w-[1200px]" : "px-[10px]"} mx-auto flex flex-col gap-5 pt-6 md:pt-8 pb-6`}
					>
						{LoginHelper.isLoggedIn() && LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_DOCTOR && (
							<>
								<CreateSection isDesktop={isDesktop} />
								<div className="spacer p-[10px]"></div>
							</>
						)}
						{LoginHelper.isLoggedIn() && LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_DOCTOR && (
							<>
								<MyWorkshopSection isDesktop={isDesktop} />
								<div className="spacer p-[10px]"></div>
							</>
						)}
						<SearchSection initQuery={queryParam} onSearch={onSearch} />
						<ExpertiseSection isDesktop={isDesktop} selectedExpertiseId={expertiseIdParam} onExpertiseClick={onExpertiseClick} />
						<WorkshopSection isDesktop={isDesktop} query={queryParam} expertiseId={expertiseIdParam} />
					</div>
				</div>
				<Footer isDesktop={isDesktop} activeButton={FooterButton.WORKSHOPS} />
			</div>
		</>
	)
}
